import { useEffect } from 'react';
import { chatOpenStore } from './useChatOpen';

// Cmd/Ctrl+U toggles the floating chat. Cmd+U is the browser "view source" shortcut;
// preventDefault suppresses it while the app has focus. (WEB-7113)
export function useGlobalChatShortcut(enabled: boolean): void {
	useEffect(() => {
		if (!enabled) return;
		const onKey = (e: KeyboardEvent) => {
			if ((e.metaKey || e.ctrlKey) && !e.shiftKey && !e.altKey && e.key.toLowerCase() === 'u') {
				e.preventDefault();
				chatOpenStore.toggle();
			}
		};
		window.addEventListener('keydown', onKey);
		return () => window.removeEventListener('keydown', onKey);
	}, [enabled]);
}
